import React from 'react'
import { ApolloProviders as SharedApolloProviders } from '@fs/zion-rootstech'
import { useFeatureFlag } from '@fs/zion-flags'
import { i18n } from '@fs/zion-locale'
import { getConfig } from '../../lib/helpers'
import { brightspotConfig } from '../../config'

const ApolloProviders = ({ children }) => {
  const persistQueries = useFeatureFlag('rootstech_persist_queries')

  return (
    <SharedApolloProviders
      persistQueries={persistQueries.isOn}
      userLocale={i18n.language}
      envConfig={getConfig()}
      apiPaths={brightspotConfig.apiPaths}
    >
      {children}
    </SharedApolloProviders>
  )
}

export default ApolloProviders
